<template>
  <el-form
      label-position="left"
      ref="form"
      :model="form"
      :disabled="disabledForm"
      size="mini">
    <el-row :gutter="10">
      <el-col v-for="(item, index) in form.items" :key="index" :span="index === 0 ? 10 : 7" :offset="0">
        <div >
          <el-form-item
              :label-width="index === 0 ? '150px' : 0"
              :label="index === 0 ? 'Payment Method *': ''"
              :prop="'items.' + index + '.paymentMethodId'"
              :rules="{ required: index === 2 ? false : true, message: 'Field is required', trigger: 'blur' }">
            <el-select
                no-data-text="no date"
                placeholder="Select Payment Method"
                class="select"
                clearable
                v-model="item.paymentMethodId"
                @change="changePaymentMethod(item)"
            >
              <el-option
                  v-for="item in paymentMethodList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div >
          <el-form-item
              :label-width="index === 0 ? '150px' : 0"
              :label="index === 0 ? 'Deposit Account *': ''"
              :prop="'items.' + index + '.depositAccountId'"
              :rules="{ required: index === 2 ? false : true, message: 'Field is required', trigger: 'blur' }">
            <el-select
                no-data-text="no date"
                placeholder="Select Deposit Account"
                :disabled="!item.paymentMethodId"
                class="select"
                clearable
                v-model="item.depositAccountId"
            >
              <el-option
                  v-for="item in item.depositAccountList"
                  :key="item.id"
                  :disabled="!item.active"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
       <div >
         <el-form-item
             :label-width="index === 0 ? '150px' : 0"
             :label="index === 0 ? 'Balance to Received': ''">
           <money :value="item.balanceToReceived" v-bind="money" disabled></money>
         </el-form-item>
       </div>
        <div >
          <el-form-item
              :label-width="index === 0 ? '150px' : 0"
              :label="index === 0 ? 'Amount Received': ''"
              :prop="'items.' + index + '.amountReceived'">
            <money v-model="item.amountReceived" v-bind="money" :disabled="disabledForm" @keydown.native="$event.key === '-' ? $event.preventDefault() : null" @change.native="$emit('calculateResults')"></money>
          </el-form-item>
        </div>
        <div >
          <el-form-item
              :label-width="index === 0 ? '150px' : 0"
              :label="index === 0 ? 'Cheque / Ref #': ''"
              :prop="'items.' + index + '.chequeRefNo'">
            <el-input placeholder="Cheque Vaucher/Ref #" v-model="item.chequeRefNo">
            </el-input>
          </el-form-item>
        </div>
  <!--      <div >-->
  <!--        <el-form-item-->
  <!--            :label-width="index === 0 ? '150px' : 0"-->
  <!--            :label="index === 0 ? 'Received Date': ''"-->
  <!--            :prop="'items.' + index + '.receivedDate'"-->
  <!--            :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">-->
  <!--          <el-date-picker-->
  <!--              v-model="item.receivedDate"-->
  <!--              :clearable='false'-->
  <!--              format="d MMM yy"-->
  <!--              value-format="MM-dd-yyyy"-->
  <!--              type="date"-->
  <!--              placeholder="Select Date">-->
  <!--          </el-date-picker>-->
  <!--        </el-form-item>-->
  <!--      </div>-->
  <!--      <div v-show="index > 1" style="display: flex; align-items: center; min-width: 113px;">-->
  <!--        <el-button v-show="index > 1" size="mini" @click="deleteItem(index)">Delete</el-button>-->
  <!--      </div>-->
      </el-col>
    </el-row>
<!--    <div style="display: flex; justify-content: flex-end; margin-top: 10px;">-->
<!--      <el-button type="primary" size="mini" @click="add">Add New payment Line</el-button>-->
<!--    </div>-->
  </el-form>
</template>

<script>
import { Money } from 'v-money'

export default {
  name: 'SplitsPaymentsMethod',
  components: {
    Money
  },
  data() {
    return {
      form: {
        items: [
          {
            // receivedDate: null,
            paymentMethodId: null,
            depositAccountId: null,
            amountReceived: 0,
            balanceToReceived: 0,
            chequeRefNo: null,
            // receivedBy: null,
            depositAccountList: []
          },
          {
            // receivedDate: null,
            paymentMethodId: null,
            depositAccountId: null,
            amountReceived: 0,
            balanceToReceived: 0,
            chequeRefNo: null,
            // receivedBy: null,
            depositAccountList: []
          },
          {
            // receivedDate: null,
            paymentMethodId: null,
            depositAccountId: null,
            amountReceived: 0,
            balanceToReceived: 0,
            chequeRefNo: null,
            // receivedBy: null,
            depositAccountList: []
          }
        ]
      },
      money: {
        precision: 2,
        decimal: '.',
        thousands: ','
      },
    }
  },
  props: {
    paymentMethodList: {
      type: Array,
      default: () => ([])
    },
    disabledForm: {
      type: Boolean,
      default: false
    }
    // receivedByList: {
    //   type: Array,
    //   default: () => ([])
    // }
  },
  // computed: {
  //   receivedByListChanged() {
  //     return this.receivedByList.filter(val => val.isChequeReceipts)
  //   }
  // },
  methods: {
    add() {
      this.form.items.push(
        {
          // receivedDate: null,
          paymentMethodId: null,
          depositAccountId: null,
          amountReceived: 0,
          balanceToReceived: 0,
          chequeRefNo: null,
          // receivedBy: null,
          depositAccountList: []
        }
      )
    },
    deleteItem(i) {
      this.form.items = this.form.items.filter((val, index) => index !== i)
    },
    changePaymentMethod(item) {
      const pm = this.paymentMethodList.find(val => val.id === item.paymentMethodId)
      if (pm) {
        item.depositAccountList = pm.accounts
        item.depositAccountId = null
      } else {
        item.depositAccountList = []
        item.depositAccountId = null
      }
    },
    validate() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          console.log('======', valid)
          resolve(valid)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  gap: 20px;
}
/deep/.el-input {
  width: 100%;
}
/deep/ .el-date-editor {
  width: 150px !important;
}
/deep/.label-without-start {
  :before {
    display: none;
  }
}
/deep/.el-form-item__label:before {
  display: none;
}
</style>